import createPage from '../../templates'

import DefaultAttachmentActions from '../../actions/attachments'
import { DefaultFirstLevelDetailActions } from '../../actions/detail'
import DefaultGridActions from '../../actions/grid'

import { getTodayDate } from '../../utils/date'

const createCasiDetail = ({ filterPath }) => createPage({
    recordParamKey: 'casoId',
    formName: 'caso',
    paramsKeys: ['casoId'],
    actions: DefaultFirstLevelDetailActions({ endpoint: `/casi` }),
    tabs: [
        {
            main: true,
            id: 'data',
            title: 'Data',
            template: 'detail',
            fieldsEndpoint: `/casi/config`,
            dataEndpoint: `/casi/:casoId`,
        },
        {
            id: 'assegnazioni-caso',
            title: 'Permessi',
            template: 'grid',
            functionName: `assegnazioni-caso`,
            childPath: `:url/assegnazioni/{{idnrr}}`,
            rowsEndpoint: `/casi/:casoId/assegnazioni`,
            actions: DefaultGridActions({
                createInitialData: ({ casoId }) => ({
                    idnrr: 0,
                    idcaso: parseInt(casoId, 10),
                    codiceTipologiaAssegnazione: 'D'
                }),
                createPath: filterPath + '/:casoId/assegnazioni/0', //'/casi/:casoId/assegnazioni/0',
                deleteEndpoint: '/casi/assegnazioni/{{idnrr}}'
            })
        },
        {
            id: 'consuntivi-caso',
            title: 'Consuntivi',
            template: 'grid',
            functionName: `consuntivi-caso`,
            childPath: `:url/consuntivi/{{idnrr}}`,
            rowsEndpoint: `/casi/:casoId/consuntivi`,
            actions: DefaultGridActions({
                createInitialData: ({ casoId }) => ({
                    idnrr: 0,
                    idcaso: parseInt(casoId, 10),
                    data: getTodayDate().toJSON()
                }),
                createPath: filterPath + '/:casoId/consuntivi/0', //'/casi/:casoId/consuntivi/0',
                deleteEndpoint: '/casi/consuntivi/{{idnrr}}'
            })
        },
        {
            title: 'Attachments',
            id: 'attachments',
            template: 'attachment',
            actions: DefaultAttachmentActions()
        }
    ],
})

export default createCasiDetail